<template>
  <span
    v-if="item.addItemIcon && isPermitted('addNewPage')"
    :class="{draggable:draggable && isPermitted('setPageLayout'),relativePos:item.id===0}"
    class="plusButton"
    @click="addNewItem"
  ><span v-if="item.id>0">&#x2195;<span v-if="!isBottom">+</span></span><span v-else>+</span></span>
</template>

<script>
import { getUserData, isPermitted } from '@/auth/utils'

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    draggable: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      isBottom: false,
      userData: null,
    }
  },
  watch: {
    item() {
      this.isThisTheBottom()
    },
  },
  created() {
    this.userData = getUserData()
    this.isThisTheBottom()
  },
  methods: {
    isThisTheBottom() {
      const items = this.$store.state.verticalMenu.menuLinks
      this.isBottom = false

      if (items && this.item && this.item.id) {
        items.forEach(element => {
          if (element.children) {
            element.children.forEach(subElement => {
              if (subElement.children) {
                if (subElement.children.findIndex(x => x.id === this.item.id) > -1) {
                  this.isBottom = true
                }
              }
            })
          }
        })
      }
    },
    isPermitted(code) {
      // skip check if pdf export
      if (!this.userData) {
        return false
      }
      return isPermitted(this.userData.role, code, this.userData.userGroups)
    },
    addNewItem() {
      if (!this.isBottom) {
        this.$root.$emit('addNewMenuItem', this.item)
      }
    },
  },
}
</script>

<style scoped>
.plusButton{
  display:inline-block;
  position: absolute;
  top: 9px;
  left: 27px;
  cursor: pointer;
  opacity: 0.01;
  color: #000;
  padding: 2px;
  transition: 0.3s;
  border-radius: 15px;
  width: 26px;
  text-align: center;
}
.plusButton:hover{
    background-color: #ddd;
    color:#333;
    opacity: 1;
}
.relativePos{
  padding: 8px;
  opacity: 0.15;
  width: inherit !important;
  position: relative !important;
  border-radius: 4px;
  border:#ddd 1px dashed;
}
.relativePos:hover{
    border:#ddd 1px solid;
    background-color: #ddd;
    color:#333;
}
.relativePos::after {
  content: " Add new item";
}
.has-sub{
  background-color: #FF0000 !important;
}
</style>
